import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  store = normalizeRoot(require('../store/index.js'), 'store/index.js')

  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../store/taxonomy/index.js'), 'taxonomy/index.js')
  resolveStoreModules(require('../store/subdomain/index.js'), 'subdomain/index.js')
  resolveStoreModules(require('../store/media/index.js'), 'media/index.js')
  resolveStoreModules(require('../store/map/index.js'), 'map/index.js')
  resolveStoreModules(require('../store/home/index.js'), 'home/index.js')
  resolveStoreModules(require('../store/faq/index.js'), 'faq/index.js')
  resolveStoreModules(require('../store/adddemo/index.js'), 'adddemo/index.js')
  resolveStoreModules(require('../store/adddemo/actions.js'), 'adddemo/actions.js')
  resolveStoreModules(require('../store/adddemo/getters.js'), 'adddemo/getters.js')
  resolveStoreModules(require('../store/adddemo/mutations.js'), 'adddemo/mutations.js')
  resolveStoreModules(require('../store/adddemo/state.js'), 'adddemo/state.js')
  resolveStoreModules(require('../store/faq/actions.js'), 'faq/actions.js')
  resolveStoreModules(require('../store/faq/getters.js'), 'faq/getters.js')
  resolveStoreModules(require('../store/faq/mutations.js'), 'faq/mutations.js')
  resolveStoreModules(require('../store/faq/state.js'), 'faq/state.js')
  resolveStoreModules(require('../store/home/actions.js'), 'home/actions.js')
  resolveStoreModules(require('../store/home/getters.js'), 'home/getters.js')
  resolveStoreModules(require('../store/home/mutations.js'), 'home/mutations.js')
  resolveStoreModules(require('../store/home/state.js'), 'home/state.js')
  resolveStoreModules(require('../store/map/actions.js'), 'map/actions.js')
  resolveStoreModules(require('../store/map/getters.js'), 'map/getters.js')
  resolveStoreModules(require('../store/map/mutations.js'), 'map/mutations.js')
  resolveStoreModules(require('../store/map/state.js'), 'map/state.js')
  resolveStoreModules(require('../store/media/actions.js'), 'media/actions.js')
  resolveStoreModules(require('../store/media/getters.js'), 'media/getters.js')
  resolveStoreModules(require('../store/media/mutations.js'), 'media/mutations.js')
  resolveStoreModules(require('../store/media/state.js'), 'media/state.js')
  resolveStoreModules(require('../store/subdomain/actions.js'), 'subdomain/actions.js')
  resolveStoreModules(require('../store/subdomain/getters.js'), 'subdomain/getters.js')
  resolveStoreModules(require('../store/subdomain/mutations.js'), 'subdomain/mutations.js')
  resolveStoreModules(require('../store/subdomain/state.js'), 'subdomain/state.js')
  resolveStoreModules(require('../store/taxonomy/actions.js'), 'taxonomy/actions.js')
  resolveStoreModules(require('../store/taxonomy/getters.js'), 'taxonomy/getters.js')
  resolveStoreModules(require('../store/taxonomy/mutations.js'), 'taxonomy/mutations.js')
  resolveStoreModules(require('../store/taxonomy/state.js'), 'taxonomy/state.js')
  resolveStoreModules(require('../store/config/site/index.js'), 'config/site/index.js')
  resolveStoreModules(require('../store/config/menu/index.js'), 'config/menu/index.js')
  resolveStoreModules(require('../store/config/locale/index.js'), 'config/locale/index.js')
  resolveStoreModules(require('../store/config/locale/actions.js'), 'config/locale/actions.js')
  resolveStoreModules(require('../store/config/locale/getters.js'), 'config/locale/getters.js')
  resolveStoreModules(require('../store/config/locale/mutations.js'), 'config/locale/mutations.js')
  resolveStoreModules(require('../store/config/locale/state.js'), 'config/locale/state.js')
  resolveStoreModules(require('../store/config/menu/actions.js'), 'config/menu/actions.js')
  resolveStoreModules(require('../store/config/menu/getters.js'), 'config/menu/getters.js')
  resolveStoreModules(require('../store/config/menu/mutations.js'), 'config/menu/mutations.js')
  resolveStoreModules(require('../store/config/menu/state.js'), 'config/menu/state.js')
  resolveStoreModules(require('../store/config/site/actions.js'), 'config/site/actions.js')
  resolveStoreModules(require('../store/config/site/getters.js'), 'config/site/getters.js')
  resolveStoreModules(require('../store/config/site/mutations.js'), 'config/site/mutations.js')
  resolveStoreModules(require('../store/config/site/state.js'), 'config/site/state.js')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
